export const environment = {
    production: false,
    appConfig: {
      adminGatewayServiceBaseUrl:"https://admin-gateway.miyarcapital.dev",
      //adminGatewayServiceBaseUrl:"http://localhost:5028",
    },
    appCDNConfig: {
      CDN: "https://mr-oss-dev-01.oss-me-central-1.aliyuncs.com/",
    },
    firebase: {
    },
    mapKey: 'AIzaSyDt-3iS_kTNAHFiFi32b2dSRU8NzlaWR8g',
  };
